export var InputTextType;
(function (InputTextType) {
    InputTextType["text"] = "text";
    InputTextType["number"] = "number";
    InputTextType["color"] = "color";
    InputTextType["date"] = "date";
    InputTextType["datetimelocal"] = "datetime-local";
    InputTextType["email"] = "email";
    InputTextType["month"] = "month";
    InputTextType["password"] = "password";
    InputTextType["tel"] = "tel";
    InputTextType["time"] = "time";
    InputTextType["url"] = "url";
    InputTextType["week"] = "week";
})(InputTextType || (InputTextType = {}));
